import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerDriverSW, registerAdminSW } from "@/lib/registerSW";

// Swallow noisy browser-extension errors that CRA's dev overlay would otherwise
// show fullscreen on top of the app (most commonly "Message Timeout" /
// "ResizeObserver loop limit exceeded" emitted by password managers,
// translation tools, ad blockers, etc.). These are NOT app errors.
const NOISE_PATTERNS = [
  /message timeout/i,
  /ResizeObserver loop/i,
  /Non-Error promise rejection captured/i,
];
const isNoise = (msg) => NOISE_PATTERNS.some((p) => p.test(String(msg || "")));

window.addEventListener(
  "error",
  (e) => {
    const msg = (e && (e.message || (e.error && e.error.message))) || "";
    if (isNoise(msg)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);
window.addEventListener(
  "unhandledrejection",
  (e) => {
    const msg = (e && (e.reason && (e.reason.message || e.reason))) || "";
    if (isNoise(msg)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerDriverSW();
registerAdminSW();
